import { gql } from '@apollo/client';

export const UPDATE_NEW_ACCOUNT_BALANCE_STATS = gql`
  mutation updateAccountStat($input: AccountStatInput!) {
    updateAccountStat(input: $input)
  }
`;
